export const RiskDatagrid = {
    list: function () {
      var options = {
        bDeferRender: true,
        data: JSON.parse(jQuery("#datagrid-list-data").html()),
        info: false,
        lengthChange: false,
        pageLength: 20,
        autoWidth: false,
        columnDefs: [
          {
            render: function (data, type, row, meta) {
              if (type == "display") {
                return jQuery("#datagrid-name-template").html().replace("__label__", data.label).replace("__href__", data.href);
              } else {
                return data.label;
              }
            },
            targets: [0],
          },
          {
            render: function (data, type, row, meta) {
              if (type == "display") {
                return jQuery("#datagrid-description-template").html().replace("__label__", data.label?.replaceAll("\n", '<br>') || '-');
              } else {
                return data.label;
              }
            },
            targets: [1],
          },
          {
            targets: [-1],
            searchable: false,
            sortable: false,
          },
        ],
        drawCallback: function () {
          ActionJS.Datagrid.priv.bindEvent();
        },
        footerCallback: function () {
          DataTablesHelper.togglePagination(this);
        }
      };
  
      var table = jQuery("#datagrid-list");
      table.DataTable(options);
  
      jQuery(".dataTables_filter").appendTo(".datatable-search");
      var searchInput = jQuery(".dataTables_filter input");
      searchInput.attr("placeholder", searchInput.closest("label").text());
    },
  
    priv: {
      bindEvent: function () {
        jQuery(".datagrid-clone-link, .datagrid-delete-link")
          .off("click")
          .on("click", function (e) {
            e.stopPropagation();
            var c = true;
            if (jQuery(this).data("confirm")) {
              c = confirm(jQuery(this).data("confirm"));
            }
            if (c) {
              jQuery
                .ajax({
                  url: jQuery(this).attr("href"),
                  method: "DELETE",
                  headers: { "X-CSRF-Token": jQuery('meta[name="csrf-token"]').attr("content") },
                })
                .done(function (d) {
                  Turbo.visit(window.location.href);
                })
                .fail(function (e) {
                  alert((((e.responseJSON || {}).id || [])[0] || {}).message || I18n.t("unexpected_error"));
                });
            }
            e.preventDefault();
          });
      },
    },
};
  